import React from 'react'
import Banner from './Banner/Banner';
import CoinsTable from './CoinsTable';

function Home() {
  return (
    <>
      <Banner/>
    <CoinsTable/>
    </>
    
 
   
  )
}

export default Home